import { Cover } from '../store/template/postPage/postPage.reducer';

export interface Style {
    [key: string]: string;
}

export interface AdditionalStyleSheet {
    style: Style;
}

function addLeadingZero(number: number) {
    return number < 10 ? `0${number}` : number;
}

function monthShouldStartFromOne(date: number) {
    return date + 1;
}

export function formatDate(receivedDate: string) {
    const date = new Date(receivedDate);
    const month = addLeadingZero(monthShouldStartFromOne(date.getUTCMonth()));
    const day = addLeadingZero(date.getUTCDate());
    const hours = addLeadingZero(date.getUTCHours());
    const minutes = addLeadingZero(date.getUTCMinutes());
    return `${date.getUTCFullYear()}${month}${day}${hours}${minutes}`;
}

export const getCoverType = (cover: Cover) => {
    if (cover.media) {
        return cover.media.type;
    }
    return 'image';
};

function getCookieByName(name: string) {
    // @ts-ignore
    return (document.cookie.match(`(^|; )${name}=([^;]*)`) || 0)[2];
}

export function getCountryCode() {
    return getCookieByName('countryCode');
}
